class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimeout = null;
    this.hoverEnabled =
      this.mainDetailsToggle?.classList.contains('taupe-shop-mega') &&
      window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (this.hoverEnabled) {
      this.openOnHover = this.openOnHover.bind(this);
      this.scheduleCloseOnLeave = this.scheduleCloseOnLeave.bind(this);
      this.cancelClose = this.cancelClose.bind(this);

      this.addEventListener('mouseenter', this.openOnHover);
      this.addEventListener('mouseleave', this.scheduleCloseOnLeave);
      this.content?.addEventListener('mouseenter', this.cancelClose);
      this.content?.addEventListener('mouseleave', this.scheduleCloseOnLeave);
    }
  }

  cancelClose() {
    clearTimeout(this.closeTimeout);
    this.closeTimeout = null;
  }

  openOnHover() {
    this.cancelClose();
    if (this.mainDetailsToggle.hasAttribute('open')) return;
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    this.onToggle();
  }

  scheduleCloseOnLeave() {
    this.cancelClose();
    this.closeTimeout = setTimeout(() => {
      if (this.matches(':hover') || this.content?.matches(':hover')) return;
      this.close();
      this.onToggle();
    }, 220);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
